import React, { useEffect, useState } from 'react';
import { Button, Spinner, Row, Col } from 'react-bootstrap';
import { ApiManager } from '../../../core/api-manager';
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';


export default function DGSH_item_model({ data, setData, selectedRows, setSelectedRows, refreshData }) {

    const [wait, setWait] = useState(false);


    async function downloadExcel() {
        setWait(true)
        console.warn(selectedRows)
        var body = {
            rows: selectedRows
        }
        var response = await ApiManager.sendAuthenticatedRequest('/custom/download_item_model_excel', body);
        if (response.success === 0) {
            toast.error(response.message, { theme: 'colored' })
        }
        else {
            try {
                const items = response.items || [];

                if (!items.length) {
                    alert('No data returned, or array is empty.');
                    return;
                }

                /**
                 * 3. Convert the JSON data to a Worksheet using SheetJS
                 *    Each object key becomes a column header.
                 */
                const worksheet = XLSX.utils.json_to_sheet(items);

                // 4. Create a new Workbook and add the worksheet
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Export');

                // 5. Write the workbook to a binary array
                //    (SheetJS has multiple "write" methods; 'array' is good for a Blob)
                const workbookBinary = XLSX.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array'
                });

                // 6. Create a Blob from the binary array
                const blob = new Blob([workbookBinary], {
                    type: 'application/octet-stream'
                });

                // 7. Create a temporary link to trigger download
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'item_model_export.xlsx'; // filename
                document.body.appendChild(link);
                link.click();

                // 8. Cleanup
                document.body.removeChild(link);
                URL.revokeObjectURL(url);

            } catch (error) {
                console.error('Error generating Excel:', error);
                alert(`Error generating Excel: ${error.message}`);
            }
        }

        setWait(false)
    }


    return (
        <>
            <Row>
                <Col md={12} xs={6} className='pe-0 my-2'>
                    {wait === true ? (
                        <Button variant='success' size='sm' className='w-100' disabled><Spinner size='sm' className='me-1' /> Scarica excel</Button>
                    ) : (
                        <Button variant='success' size='sm' className='w-100' onClick={() => downloadExcel()}>Scarica excel</Button>
                    )}
                </Col>
            </Row>
        </>
    )
};